import {Channel, Platform} from './common';

export enum PostType {
  POST = 'post',
  STORY = 'story',
  REEL = 'reel'
}

export class Post {
  urlHash: string | null;
  date: string | null;
  publishedDate: any | null;
  impression: number | null;
  reach: number | null;
  engagement: number | null;
  impact: number | null;
  influencerId: number | null;
  influencerName: string | null;
  title: string | null;
  image: string | null;
  // cdn video link
  video: string | null;
  listOfMention: string | null;
  mentions: string | string[] | null;
  topicId: number | null;
  topicName: string | null;
  postRank: number | null;
  engagementType: string | null;
  engagementPercent: number | null;
  url: string | null;
  relativePath: string | null;
  channel: PostChannel;
  platform: Platform;
  comments: number | 0;
  playlists: number | 0;
  dislikes: number | 0;
  shares: number | 0;
  views: number | 0;
  likes: number | 0;
  performingScore: number;
  content: string | null;
  isStory: boolean;
  completed: boolean;
  isVideo: boolean;
  mediaWidth: number;
  mediaHeight: number;
  imageWidth: number;
  imageHeight: number;
  authorized: boolean;
  replies: number;
  story: boolean;
  tapsForward: number | 0;
  tapsBack: number | 0;
  exits: number | 0;
  isPaidPartnership: boolean;
  sponsors: Sponsor[];
  postType: PostType;
  channelUrl: string;
  plays: number;
}

export class PostChannel {
  id: number | null;
  blog_id: number | null;
  handle: string | null;
  isLinked: number | null;
  note: string | null;
  platform: Platform | null;
  platform_id: number | null;
  platformName: string | null;
  rss_url: string | null;
  token: string | null;
  type: number | null;
  youtubeType: string | null;
}

export class PostActivityPieChartDataItem {
  name: string | null;
  percent: number | 0;
  value: number | 0;

  constructor(name: string = null, percent: number = 0, value: number = 0) {
    this.name = name;
    this.percent = percent;
    this.value = value;
  }
}

export class SameInfluencerTopPost {
  referenceKpi: PostPieCharts | null;
  postRank: number | 1;
  title: string | null;
  url: string | null;
  urlHash: string | null;
  currentPost: boolean | false;
  channel: Channel | null;
}
export class PostPieCharts {
  engagement: {
    other: number | 0,
    percent: number | 0,
    value: number | 0,
  };
  impact: {
    other: number | 0,
    percent: number | 0,
    value: number | 0,
  };
  reach: {
    other: number | 0,
    percent: number | 0,
    value: number | 0,
  };
}
export class RelatedPost {
  date: string | null;
  picture: string | null;
  pieCharts: PostPieCharts | null;
  text: string | null;
  url: string | null;
}

export class PostActivityLineChartDataItem {
  date: number | 0;
  engagement: number | 0;
  engagementPercent: number | 0;
  engagementType: number | 0;
  image: string | null;
  impact: number | 0;
  impression: number | 0;
  influencerId: number | 0;
  influencerName: string | null;
  listOfMention: string[];
  postRank: number | 0;
  publishDate: number | 0;
  reach: number | 0;
  relativepath: string | null;
  title: string | null;
  topicId: number | 0;
  topicName: string | null;
  url: string | null;
  urlHash: string | null;
}

export interface Sponsor {
  id: string;
  handle: string;
}



// WEBPACK FOOTER //
// ./src/models/post-overview.ts